import './App.css';
import Layout from './components/Layout/Layout.js';
import Home from './components/Home/Home.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Education from './components/Education/Education.js';
import Tech from './components/Tech/Tech.js';
import Projects from './components/Projects/Projects.js';
import Experience from './components/Experience/Experience.js';
import Contact from './components/contact/Contact.js';
import Achievement from './components/Acheivement/Achievement.js';

const SectionDivider = () => (
  <div className="w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent relative my-0 overflow-visible">
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent blur-md opacity-30 animate-pulse"></div>
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full blur-[2px] shadow-[0_0_10px_#ffffff]"></div>
  </div>
);

function App() {
  return (
    <div className="bg-[#0b0f19]">
      <ToastContainer />
      <Router>
        <Layout />
        <main className="w-full snap-y snap-mandatory overflow-x-hidden">
          <section id="home" className="w-full min-h-screen snap-start"><Home /></section>
          <SectionDivider />
          <section id="education" className="w-full min-h-screen snap-start"><Education /></section>
          <SectionDivider />
          <section id="tech" className="w-full min-h-screen snap-start"><Tech /></section>
          <SectionDivider />
          <section id="experience" className="w-full min-h-screen snap-start"><Experience /></section>
          <SectionDivider />
          <section id="project" className="w-full min-h-screen snap-start"><Projects /></section>
          <SectionDivider />
          <section id="achievement" className="w-full min-h-screen snap-start"><Achievement /></section>
          <SectionDivider />
          <section id="contact" className="w-full min-h-screen snap-start"><Contact /></section>
        </main>
      </Router>
    </div>
  );
}

export default App;
